export default __webpack_public_path__ + "static/media/R_Rei.ecd95d05.svg";